import React from "react";

// Draws Instagram/Canva-style orange snap guide lines over the sheet.
// `guides` is [{ type: "v" | "h", pos }] in unscaled page coordinates —
// this must sit inside the same (unscaled, pre-transform) container as
// the elements themselves so the positions line up.
export default function SnapGuides({ guides, pageW, pageH }) {
  if (!guides || guides.length === 0) return null;
  return (
    <>
      {guides.map((g, i) =>
        g.type === "v" ? (
          <div
            key={`v-${i}`}
            style={{
              position: "absolute",
              left: g.pos,
              top: 0,
              width: 0,
              height: pageH,
              borderLeft: "1px dashed #FF7A00",
              pointerEvents: "none",
              zIndex: 999,
            }}
          />
        ) : (
          <div
            key={`h-${i}`}
            style={{
              position: "absolute",
              left: 0,
              top: g.pos,
              width: pageW,
              height: 0,
              borderTop: "1px dashed #FF7A00",
              pointerEvents: "none",
              zIndex: 999,
            }}
          />
        )
      )}
    </>
  );
}
